<script>
import DonationAppFeeChangeModal from '@/components/fundraisers/donation-app-fee-change-modal.vue'
import TwButton from '@/components/generic/tw-button.vue'
import donateCommonAppFeesMixin from '@/mixins/donations/donateCommonAppFeesMixin.js'

export default {
  name: 'FundraiserDonationAppFeeCard' ,
  components: { TwButton, DonationAppFeeChangeModal },
  mixins:[donateCommonAppFeesMixin],
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    donationAmount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      default: 'USD'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      EditorActive: false
    }
  },
  computed: {
    proposedAppFeeMinimum() {
      return 1
    },
    proposedAppFeeMaximum() {
      return this.donationAppFeeAmountProposed(this.donationAmount) - 1
    },
    proposedAppFeeMiddle() {
      // we split the difference between minimum and maximum with 2 decimals
      const middle = (this.proposedAppFeeMaximum + this.proposedAppFeeMinimum)/2
      return parseFloat(middle.toFixed(2))
    },
    modelValueFormatted() {
      return this.$filters.formatCurrency(this.modelValue, this.currency)
    }
  },
  methods: {
    update(val) {
      this.$emit('update:modelValue', val)
      this.EditorActive = false
    },
    formatAppFee(amount) {
      return this.$filters.formatCurrency(amount, this.currency)
    }
  }
}
</script>

<template>
  <div class="bg-amber-50 rounded-lg p-5 text-sm">
    <div v-if="EditorActive">
      <h6>
        Your optional contribution helps keep GroupRev Free
      </h6>
      <div class="mt-4 grid grid-cols-4 gap-2">
        <tw-button size="sm" block :variant="modelValue === proposedAppFeeMaximum? 'white':'outline'" class="border border-gray-300 hover:bg-amber-100" @click="update(proposedAppFeeMaximum)">
          {{ formatAppFee(proposedAppFeeMaximum) }}
        </tw-button>
        <tw-button size="sm" block :variant="modelValue === proposedAppFeeMiddle? 'white':'outline'" class="border border-gray-300 hover:bg-amber-100" @click="update(proposedAppFeeMiddle)">
          {{ formatAppFee(proposedAppFeeMiddle) }}
        </tw-button>
        <tw-button size="sm" block :variant="modelValue === proposedAppFeeMinimum? 'white':'outline'" class="border border-gray-300 hover:bg-amber-100" @click="update(proposedAppFeeMinimum)">
          {{ formatAppFee(proposedAppFeeMinimum) }}
        </tw-button>
        <tw-button size="sm" block variant="outline" class="hover:bg-amber-100" @click="$refs.DonationAppFeeChangeModal.open()">
          Other
        </tw-button>
      </div>
    </div>
    <div v-else>
      <div class="font-semibold">
        <span v-if="modelValue > 0" class="text-xs">+{{ modelValueFormatted }} Optional Contribution ❤️</span>
      </div>
      <div class="mt-1 text-xxs leading-4">
        <span>GroupRev helps organizations raise millions for meaningful causes. Your small contribution helps keep the platform free.</span>
        <tw-button variant="link" class="text-xxs ml-1 font-normal underline text-gray-500" @click="EditorActive = !EditorActive">
          Edit
        </tw-button>
      </div>
    </div>
    <donation-app-fee-change-modal ref="DonationAppFeeChangeModal" :currency="currency" @update:model-value="update($event)" />
  </div>
</template>

<style scoped>

</style>
